import React from "react";
import preview from "../../../assets/portfolio/dealerinspire/preview.webp";

export default function DealerInspire() {
	return (
		<div
			style={{ margin: "0 2rem", width: "calc(50% - 4rem)" }}
			data-aos="fade-up">
			<h2
				style={{
					fontWeight: 400,
					fontSize: "16px",
					lineHeight: "16px",
					margin: "1rem 0",
				}}>
				Dealer Inspire{" "}
			</h2>
			<h3>GA4 Tracking and Measurement</h3>
			<p>Implementation of custom tracking events using VanillaJS.</p>
			<div
				style={{
					width: "100%",
					height: "600px",
					overflow: "hidden",
					borderRadius: "10px",
					paddingLeft: "2rem",
					paddingTop: "2rem",
					backgroundColor: "#3076E2",
				}}>
				<img
					src={preview}
					alt="Dealer Inspire GA4 Tracking"
					style={{ height: "100%" }}
				/>
			</div>
		</div>
	);
}
